import { Observable } from "rxjs/Observable"

import {
    STUDIO_BRIEFING_REQUEST,
    STUDIO_BRIEFING_EMAIL_REQUEST
} from "../actions/action-types"
import { downloadFile } from "../config/util-functions"
import { getMapBriefing, sendMapBriefingEmail } from "../api/map-api"
import { mapRequestError } from "./default-epics/epic-utils"
import {
    studioBriefingResponse,
    studioBriefingErrorResponse,
    studioBriefingEmailResponse,
    studioBriefingEmailErrorResponse
} from "../actions/studio-actions"
import { unauthenticated } from "../actions/authentication-actions"

export const studioBriefingRequestEpic = (action$, { getState }) =>
    action$.ofType(STUDIO_BRIEFING_REQUEST).mergeMap(({ id }) => {
        const state = getState()
        const { token } = state.authentication
        const name = state.presentation.studio.workingModel.name
        return getMapBriefing(token, id)
            .map(({ response }) => {
                const fileName = `Dynamic Briefing - ${name}.pdf`
                downloadFile(response, fileName)

                return studioBriefingResponse()
            })
            .catch(error =>
                Observable.of(
                    mapRequestError(
                        error,
                        unauthenticated,
                        studioBriefingErrorResponse,
                        id
                    )
                )
            )
    })

export const studioBriefingEmailRequestEpic = (action$, { getState }) =>
    action$.ofType(STUDIO_BRIEFING_EMAIL_REQUEST).mergeMap(({ id, item }) => {
        const { token } = getState().authentication
        const briefingEmail = item
            .set("recipients", item.recipients.map(({ email }) => email))
            .toJS()
        return sendMapBriefingEmail(token, id, briefingEmail)
            .map(_ => studioBriefingEmailResponse())
            .catch(error =>
                Observable.of(
                    mapRequestError(
                        error,
                        unauthenticated,
                        studioBriefingEmailErrorResponse,
                        item
                    )
                )
            )
    })
